/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListKind } from './listKind';

export interface GetListRequest {
  listKind: ListKind;
}
export namespace GetListRequest {}
